export const guiStateUpdateToastReducer = (guiState, action) => (Object.assign(Object.assign({}, guiState), { toast: action.payload.toastProps }));
//# sourceMappingURL=reducer.js.map